<template>
  <div class="repayment-item" @click="handleClick">
    <div class="repayment-info">
      <div class="info-top">
        <div class="period">服务费</div>
        <div class="repayment-date">
          还款日期：{{ itemData?.serviceFeeGatherTime || "--" }}
        </div>
      </div>
      <div class="repayment-amount">
        <div class="checkbox">
          <input
            type="checkbox"
            ref="repaymentCheckbox"
            v-model="isChecked"
            @change.stop="handleChange"
          />
        </div>
        <div class="info-bottom">
          <div class="interest">
            服务费{{ itemData?.serviceFee?.toFixed(2) || "--" }}
          </div>
        </div>
        <div class="amount">
          <span class="amount-tip">¥</span
          >{{ itemData?.serviceFee?.toFixed(2) || "--" }}
        </div>
      </div>
    </div>
    <div class="repayment-status" v-if="itemData.serviceFeeStatus == 2">
      <div class="status">{{ orderStatusList[itemData.serviceFeeStatus] }}</div>
    </div>
    <div class="amount-due" v-if="itemData.serviceFeeStatus == 1">
      <div class="status">{{ orderStatusList[itemData.serviceFeeStatus] }}</div>
    </div>
  </div>
</template>

<script>
import { uniqueById, amountFormatter } from "@/utils/utils.js";
import { orderStatusList } from "@/utils/const.js";

export default {
  name: "repaymentItem",
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
    num: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isChecked: false,
      uniqueById,
      orderStatusList,
      amountFormatter,
    };
  },
  async mounted() {},
  methods: {
    handleChange() {
      this.$store.commit(
        "setServiceFee",
        this.isChecked
          ? [...this.$store.state.serviceFee, this.itemData]
          : this.$store.state.serviceFee.filter(
              (item) =>
                item.borrowOrderIssueId !== this.itemData.borrowOrderIssueId,
            ),
      );
    },
    handleClick() {
      this.isChecked = !this.$refs.repaymentCheckbox.checked;
      this.$store.commit(
        "setServiceFee",
        this.isChecked
          ? [...this.$store.state.serviceFee, this.itemData]
          : this.$store.state.serviceFee.filter(
              (item) =>
                item.borrowOrderIssueId !== this.itemData.borrowOrderIssueId,
            ),
      );
    },
  },
};
</script>

<style scoped lang="scss">
.repayment-item {
  padding: 16px 9px 10px 9px;
  border-radius: 8px;
  background: #ffffff;
  position: relative;
  display: flex;
  margin: 10px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.06);
  .repayment-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    .info-top,
    .info-bottom {
      display: flex;
      align-items: center;
    }
    .info-top {
      font-size: 12px;
      .period {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #d4a038;
        padding: 2px 0px;
        color: #d4a038;
        font-family: YEFONTAoYeHei, YEFONTAoYeHei;
        font-weight: 600;
        text-align: center;
        width: 46px;
      }
      .repayment-date {
        color: #333333;
        margin-left: 6px;
        font-size: 14px;
      }
    }
    .info-bottom {
      font-size: 11px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      /* 列与列之间间距 10px，行与行（换行后）之间间距 8px */
      column-gap: 0px;
      row-gap: 8px; /* 🌟 只要换行，下方的元素自动产生 8px 的顶部间距 */
      color: #999999;
    }
  }
  .repayment-amount {
    font-size: 12px;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    .amount {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
      margin-left: auto; /* 核心代码：自动撑开左侧间距 */
      .amount-tip {
        font-size: 12px;
      }
    }
  }
  .repayment-status {
    position: absolute;
    right: 0px;
    top: 0px;
    .status {
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      padding: 2px 6px;
      background-image: url("@/assets/style/overdue-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .amount-due {
    position: absolute;
    right: 0px;
    top: 0px;
    .status {
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      padding: 2px 6px;
      background-image: url("@/assets/style/Amount-due.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #cfcfcf;
  border-radius: 50%;
  margin-right: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  flex-shrink: 0;

  &:checked {
    background-color: #F24334;
    border: none;
    &::after {
      content: "";
      width: 8px;
      height: 4px;
      border: 2px solid #fff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg);
      margin-top: -2px;
    }
  }
}
</style>
